import React, { Fragment, useContext, useState } from 'react'
import { AiFillHome } from "@react-icons/all-files/ai/AiFillHome";
import { BsCalendar } from "@react-icons/all-files/bs/BsCalendar";


import { MdFamilyRestroom,MdTipsAndUpdates, MdKeyboardArrowRight, MdOutlineKeyboardArrowRight, MdFullscreen } from 'react-icons/md';
import { IoDocumentTextOutline, IoIosDocument, IoMdArrowDropdown, IoMdBook } from 'react-icons/io';
import { FaPlus } from 'react-icons/fa';
import { AiOutlineQuestionCircle, AiFillFolder, AiFillFile, AiOutlineCloseCircle, AiOutlineSearch, AiOutlinePlusCircle} from 'react-icons/ai'
import {SiHandshake} from 'react-icons/si'
import { BiCalendar, BiEdit, BiTrash} from 'react-icons/bi'
import Renderif from '../../components/renderif';
import SideMenu, { AdminSideMenu } from '../../components/sidemenu';

import CheckBox from '../../components/checkbox';
import DropDown, { DropDownOption } from '../../components/dropdown';
import BVCalendar from '../../components/calendar';
import { gray30, primary } from '../../utils/colors';
import Slider from '../../components/slider';
// import AgendarCitaFamiliar from './agendar_familia_client';
import { Await, useNavigate } from 'react-router-dom';
import { Service } from '../../services/api';
import { AlertContext } from '../../context/alert_context';
import { GoStarFill } from "react-icons/go";
import { GoStar } from "react-icons/go";
import { BsArrowRightSquareFill, BsClock, BsFillPersonFill } from "react-icons/bs";
import { FiShoppingBag } from 'react-icons/fi';
import { IoStatsChart } from 'react-icons/io5';
import { CgHashtag } from 'react-icons/cg';
import { AuthContext } from '../../context/auth_context';






export default function ValoracionesAdmin() {

    const {notify} = useContext(AlertContext)
    const navigate = useNavigate();
    const {user} = useContext(AuthContext)
    const [state, setState] = useState({ 
        open:null
    })

    useState(()=>{
        const init = async () => {
   
        };
        init();
        return () => {}
    },[])

 
    const y = [0,30, 60, 90, 120, 150]
    const x = [
        {
            date:'1 Ago',
            value:40
        },
        {
            date:'1 Ago',
            value:120
        },
        {
            date:'1 Ago',
            value:60
        },
        {
            date:'1 Ago',
            value:83
        },
        {
            date:'1 Ago',
            value:150
        }
    ]
    var weekday=new Array(7);
    weekday[0]="Sunday";
    weekday[1]="Monday";
    weekday[2]="Tuesday";
    weekday[3]="Wednesday";
    weekday[4]="Thursday";
    weekday[5]="Friday";
    weekday[6]="Saturday";

    var months=new Array(7);
    months[0]="January";
    months[1]="Febrary";
    months[2]="March";
    months[3]="April";
    months[4]="May";
    months[5]="June";
    months[6]="July";
    months[7]="August";
    months[8]="September";
    months[9]="Octuber";
    months[10]="November";
    months[11]="December";


  return (
   

    <div className='container-fluid h-100 d-flex'>


        {/* <SideMenu></SideMenu> */}
        <AdminSideMenu></AdminSideMenu>
    
        <div className='col hide-scroll'>

            <div className='container-fluid bg-light'>

                <div className='container'>
                    <div className='row'>
                        <div className='d-flex align-items-center bg-light p-3'>


                            <div className='d-flex align-items-center'>
                                    <div className='avatar avatar--mid'></div>
                                    <div className='col ps-3'>
                                        <div className='f-18 bold '>¡Hola! {user.firstName} {user.lastName}.</div>
                                        <div className='text-gray f-14 line-0'>Medicina General</div>
                                    </div>
                            </div>
                            <div className='col'></div>
                           <div  className='mx-3'>
                            <div className='input--light'>
                                    <div className='bv-icon bv-icon--mid'><AiOutlineSearch size={30}></AiOutlineSearch></div>
                                    <input className='bg-transparent' placeholder='Busca Especialista'></input>
                                </div>
                           </div>
                           <div className='bv-cta bv-cta--primary' onClick={()=> {
                                // setState({...state, show_agendar_cita:true})
                                navigate('/administrador/calendario')
                            }}>
                                Ver Agenda
                    
                            </div>

                            
                        </div>
                    </div>
                </div>
            </div>

            <div className='container mt-4 '>


          

                <div className='row m-0'>
                    <div className='col-12 m-0 p-0'>


                        {/* <div className='d-flex align-items-center my-3'>
                                <div className='bv-pill bv-pill--primary d-flex align-items-center ps-0 cursor-pointer me-1' onClick={()=>{
                                    setState({...state, show_add:'agregar-tag'})
                                }}>
                                    <div className='ps-0'> <AiOutlinePlusCircle size={22}/></div>
                                    <div className='px-1'>Agregar Especialista</div>
                                </div>
                                <div className='col'></div>
                                <div className='bv-cta bv-cta--primary' onClick={()=> {
                                // setState({...state, show_agendar_cita:true})
                            }}>
                                Ver Agenda
                    
                            </div>
                        </div> */}

                 
                        <div className='bv-table d-none d-sm-block'>
                            <table className='w-100'>
                                <thead>
                                    <tr>
                                        <td>
                                            <div className='d-flex align-items-center'>

                                                {/* <div className='bv-icon'><BsFillPersonFill size={12} color="#777777" /></div> */}
                                                <div className='text-gray line-0 f-14 bold'>Nombre</div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center'>
                                                {/* <div className='bv-icon'><BsCalendar size={12} color="#777777" /></div> */}
                                                <div className='text-gray f-14 bold line-0'>Correo</div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center justify-content-center'>
                                                {/* <div className='bv-icon'><BsClock size={12} color="#777777" /></div> */}
                                                <div className='text-gray f-14 bold line-0'>Sesiones</div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center justify-content-center'>
                                                {/* <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div> */}
                                                <div className='text-gray f-14 bold line-0'>Retención</div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center justify-content-center'>
                                                {/* <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div> */}
                                                <div className='text-gray f-14 bold line-0'>Efectividad</div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center justify-content-center'>
                                                {/* <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div> */}
                                                <div className='text-gray f-14 bold line-0'>Cronograma</div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center'>
                                                {/* <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div> */}
                                                <div className='text-gray f-14 bold line-0'>Valoración</div>
                                            </div>
                                        </td>
                                        <td></td>
                                        <td></td>

                            
                                    </tr>
                                </thead>
                                <tbody>
                                {[1,2,3,4,5].map((item,i)=>{
                                    return (
                                        <Fragment key={i}>

                                            <tr className="">
                                                <td>
                                                    <div>
                                                        <div className='d-flex align-items-center'>
                                                                <div className='avatar'></div>
                                                                <div className='col ps-3'>
                                                                    <div className='text-gray f-14 bold'>Nombre Completo</div>
                                                                    <div className='text-gray f-14 line-0'></div>
                                                                </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        <div className='text-gray f-12'>Correo</div>
                                                    
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        <div className='text-gray text-center f-12'>10</div>
                                                    
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        <div className='text-gray text-center f-12'>10%</div>
                                                    
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        <div className='text-gray text-center f-12'>10%</div>
                                                    
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        <div className='text-gray text-center f-12'>10%</div>
                                                    
                                                    </div>
                                                </td>


                                               
                                              
                                                <td>
                                                    <div>
                                                        <Rating value={4}></Rating>
                                                    
                                                    </div>
                                                </td>
                                             <td></td>
                                               
                                            
                                    
                                            <td>
                                                <div className={`bv-pill bv-pill--${state.open === i ? 'gray':'green'} cursor-pointer`} onClick={(evt)=>{
                                                    evt.stopPropagation();
                                                    if(state.open === i){
                                                        setState({...state, open:null})
                                                    }else{
                                                    setState({...state, open:i})
                                                    }
                                                 
                                                }}>
                                                    Ver detalles
                                                </div>
                                            </td>
                                                
                                            </tr>
                                            <Renderif isTrue={state.open === i}>   
                                            <tr>
                                                <td>
                                                    <div className='text-gray f-12'>Valoraciones y Reseñas</div>
                                                </td>
                                                
                                             
                                                <td colSpan={3} className='p-0'>
                                                    <div className='my-3 d-flex'>
                                                        
                                                        <div className='col'> 
                                                            <div className='d-flex align-items-center'>
                                                                <div className='f-12 text-gray bold px-1'>5</div>
                                                                <div className='bar'>
                                                                    <div className='bar-value' style={{width:'100%'}}></div>
                                                                </div>
                                                            </div>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='f-12 text-gray bold px-1'>4</div>
                                                                <div className='bar'>
                                                                    <div className='bar-value' style={{width:'80%'}}></div>
                                                                </div>
                                                            </div>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='f-12 text-gray bold px-1'>3</div>
                                                                <div className='bar'>
                                                                    <div className='bar-value' style={{width:'60%'}}></div>
                                                                </div>
                                                            </div>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='f-12 text-gray bold px-1'>2</div>
                                                                <div className='bar'>
                                                                    <div className='bar-value' style={{width:'40%'}}></div>
                                                                </div>
                                                            </div>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='f-12 text-gray bold px-1'>1</div>
                                                                <div className='bar'>
                                                                    <div className='bar-value' style={{width:'20%'}}></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='px-3'>
                                                            <div className='d-flex align-items-center'>
                                                                <div>4.5</div>
                                                                <div className='bv-icon bv-icon--mid'>
                                                                    <GoStarFill color='#FFA800'></GoStarFill>
                                                                </div>
                                                            </div>
                                                            <div className='f-12 text-gray'>232 reseñas</div>
                                                            <div className='f-12 text-gray'>85% recomendado.</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td colSpan={1} className=''>
                                                    <div className='text-gray f-12'>Paciente</div>
                                                </td>
                                                <td colSpan={1} className=''>
                                                    <div className='text-gray f-12'>Correo</div>
                                                </td>
                                                <td colSpan={1} className=''>
                                                    <div className='text-gray f-12'>fecha</div>
                                                </td>
                                                <td colSpan={3} className=''>
                                                    <div className='text-gray f-12'>
                                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                                    </div>
                                                </td>
                                               
                                                <td colSpan={1} className=''>
                                                    <div className=''>
                                                        <Rating value={3}></Rating>
                                                    </div>
                                                </td>
                                                <td></td>
                                                <td>
                                                    <div className={`bv-pill bv-pill--green cursor-pointer`} onClick={(evt)=>{
                                                        evt.stopPropagation();
                                                    
                                                    }}>
                                                        Ver seguimiento
                                                    </div>
                                                </td>
                                            </tr>
                                            </Renderif>  
                                            
                                            

                                    
                                        </Fragment>
                                    )
                                })}
                                
                                </tbody>
                            
                            </table>

                            <div className='pt-5'></div>
                            <div className='mt-5'></div>

                            <div className='d-flex align-items-center mt-5 p-2'>

                                <div className='text-gray f-12 line-0'>Mostrar</div>


                            <div className='mx-2'>
                                <DropDown 
                                        title=''
                                        open={false}
                                        defaultValue={5} 
                                        _onChange={(evt)=>{
                                        console.log(evt)
                                    }}>
                                        <DropDownOption value={5} label="5">
                                            <div className='f-14 text-gray'>5</div>
                                        </DropDownOption>
                                        <DropDownOption value={10} label="10">
                                            <div className='f-14 text-gray'>10</div>
                                        </DropDownOption>
                                    
                                    
                                        
                                    </DropDown>
                            </div>
                            


                            {/* <div className='d-flex bv-dropdown mx-2'>
                                    <div className='text-black bold f-12 ms-1'>5</div>
                                    <div className='line-0'><IoMdArrowDropdown size={18} color="#000000" /></div>
                            </div> */}


                                <div className='text-gray f-12 line-0'>Por Página</div>
                                <div className='col'></div>


                            </div>
                        </div>
                    

                    </div>

                </div>

          
             
        
            </div>

            <div className='my-5'></div>
        </div>
    </div>

  )
}



export function Rating({value = 5}) {
    
  return (
    <div className='d-flex'>
        <div className='bv-icon '>

            <Renderif isTrue={value > 0}>
                <GoStarFill color='#FFA800'></GoStarFill>
            </Renderif>
            <Renderif isTrue={value < 1}>
                <GoStar color='#CCC'></GoStar>
            </Renderif>
           
        </div>

        <div className='bv-icon'>
             <Renderif isTrue={value > 1}>
                <GoStarFill color='#FFA800'></GoStarFill>
            </Renderif>
            <Renderif isTrue={value < 2}>
                <GoStar color='#CCC'></GoStar>
            </Renderif>
        </div>

        <div className='bv-icon'>
             <Renderif isTrue={value > 2}>
                <GoStarFill color='#FFA800'></GoStarFill>
            </Renderif>
            <Renderif isTrue={value < 3}>
                <GoStar color='#CCC'></GoStar>
            </Renderif>
        </div>

        <div className='bv-icon'>
            <Renderif isTrue={value > 3}>
                <GoStarFill color='#FFA800'></GoStarFill>
            </Renderif>
            <Renderif isTrue={value < 4}>
                <GoStar color='#CCC'></GoStar>
            </Renderif>
        </div>

        <div className='bv-icon'>
            <Renderif isTrue={value > 4}>
                <GoStarFill color='#FFA800'></GoStarFill>
            </Renderif>
            <Renderif isTrue={value < 5}>
                <GoStar color='#CCC'></GoStar>
            </Renderif>
        </div>
    </div>
  )
}


